import { render, staticRenderFns } from "./websiteCustomInfo.vue?vue&type=template&id=3028edee&"
import script from "./websiteCustomInfo.vue?vue&type=script&lang=js&"
export * from "./websiteCustomInfo.vue?vue&type=script&lang=js&"
import style0 from "./websiteCustomInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports